module.exports = __webpack_public_path__ + "static/media/insta-1_thumb.6b34b5ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/insta/insta-1_thumb.jpg
// module id = 182
// module chunks = 0